<template>
    <div>
        <span>{{ internalFullname }} </span>
        <br
            v-if="hasEmail"
            v-bind:class="responsiveClasses.nameEmailBreak" />
        <span
            v-if="hasEmail"
            v-bind:class="responsiveClasses.nameEmailSeparator">
            |
        </span>
        <span v-if="hasEmail">{{ internalEmail }}</span>
    </div>
</template>
<script>
    import { WIDE_BP } from "Projects/SharedCapsules/_sharedCapsuleBase";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        nameEmailSeparator: {
            d: { xs: "none", [WIDE_BP.name]: "inline" }
        },
        nameEmailBreak: {
            d: { xs: "block", [WIDE_BP.name]: "none" }
        }
    };

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            first: { type: String, required: false, default: null },
            last: { type: String, required: false, default: null },
            email: { type: String, required: false, default: null },
            contactInfoObj: { type: Object, required: false, default: null }
        },
        computed: {
            internalFirst() {
                return this.first ?? this.contactInfoObj?.first;
            },
            internalLast() {
                return this.last ?? this.contactInfoObj?.last;
            },
            // need to localize first name and last name order
            internalFullname() {
                if (this.internalFirst == null && this.internalLast == null) {
                    return "";
                }
                return this.internalFirst + " " + this.internalLast;
            },
            internalEmail() {
                return this.email ?? this.contactInfoObj?.email;
            },
            hasEmail() {
                return Boolean(this.internalEmail);
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            }
        }
    };
</script>
